/*
 *
 *   reducer
 *
 */
import produce from "immer"
//import key from './key'

import {
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,
  LOAD_DATA_COPY_SUCCESS,
  LOAD_DATA_COPY_ERROR,

  ADD_DATA_SCHEDULING_SUCCESS,
  ADD_DATA_SCHEDULING_ERROR,
  REMOVE_DATA_SERVICE_SUCCESS,
  REMOVE_DATA_SERVICE_ERROR,
  LOAD_DATA_SCHEDULING_SERVICE_SUCCESS,
  LOAD_DATA_SCHEDULING_SERVICE_ERROR,
  LOAD_DATA_SCHEDULING_SUCCESS,
  LOAD_DATA_SCHEDULING_ERROR,
  UPDATE_DATA_SCHEDULING_SUCCESS,
  UPDATE_DATA_SCHEDULING_ERROR,
  SHOOTER_HISTORY_LIST_SUCCESS,
  SHOOTER_HISTORY_LIST_ERROR,
  DATA_FINAL_COMMIT_SUCCESS,
  DATA_FINAL_COMMIT_ERROR,
  AGENT_VANCANY_LIST_SUCCESS,
  AGENT_VANCANY_LIST_ERROR,
  AGENT_OFFICE_VACANCY_LIST_SUCCESS,
  AGENT_OFFICE_VACANCY_LIST_ERROR,
  LOAD_NAS_LINK_DETAILS_SUCCESS,
  ADD_NAS_LINK_SUCCESS,
  DELETE_NAS_LINK_SUCCESS,
  UPDATE_NAS_LINK_SUCCESS,
  ADD_DATA_LINK_SUCCESS,
  DELETE_DATA_LINK_SUCCESS,
  UPDATE_DATA_LINK_SUCCESS,
  LOAD_NAS_LINK_DETAILS_ERROR,
  ADD_NAS_LINK_ERROR,
  UPDATE_NAS_LINK_ERROR,
  DELETE_NAS_LINK_ERROR,
  LOAD_DATA_LINK_DETAILS_ERROR,
  ADD_DATA_LINK_ERROR,
  UPDATE_DATA_LINK_ERROR,
  DELETE_DATA_LINK_ERROR,
  LOAD_SERVICE_LEVEL_SUCCESS,
  LOAD_DATA_LINK_DETAILS_SUCCESS,
  LOAD_PENDING_STATUS_SUCCESS,
  LOAD_PENDING_STATUS_ERROR,
  LOAD_DATA_DETAILS_SUCCESS,
  LOAD_DATA_DETAILS_ERROR,
  LOAD_EXPAND_DATA_SUCCESS,
  LOAD_EXPAND_DATA_ERROR
} from "./constants"

const initialState = {
  recordsMetaData: {},
  data_copy_details: [],
  data_link_details: [],
  nas_link_details: [],
  applyClearance: {},
  loading: false,
  error: false,
  success: false,
  record: [],
  data_scheduling_details: [],
  data_scheduling_services: [],
  agent_vacancy_details: [],
  agent_office_details: [],
  shooter_history: [],
  serviceLevel_details: [],
  deleteNasLinkData: {},
  pendingData: [],
  dataDetails: [],
  expandData: []
}

export default function Reducer(
  state = initialState,
  {
    type,
    recordsMetaData = {},
    data_copy_details = [],
    data_link_details = [],
    nas_link_details = [],
    error,
    success,
    data_scheduling_details,
    agent_office_details,
    data_scheduling_services,
    agent_vacancy_details,
    shooter_history,
    record,
    serviceLevel_details = [],
    deleteNasLinkData = {},
    pendingData = [],
    dataDetails = [],
    expandData = []
  }
) {
  return produce(state, (draft) => {
    switch (type) {
      case LOAD_RECORDS_META_DATA_SUCCESS:
        draft.recordsMetaData = Object.assign(
          {},
          state.recordsMetaData,
          recordsMetaData
        )
        draft.error = false
        draft.success = success
        break
      case LOAD_PENDING_STATUS_SUCCESS:
        draft.pendingData = pendingData
        draft.lastUpdate = Math.floor(Date.now() / 1000)
        draft.loading = false
        draft.error = false
        draft.success = success
        break
      case LOAD_DATA_COPY_SUCCESS:
        draft.data_copy_details = data_copy_details
        draft.lastUpdate = Math.floor(Date.now() / 1000)
        draft.loading = false
        draft.error = false
        draft.success = success
        break
      case LOAD_DATA_SCHEDULING_SUCCESS:
        draft.data_scheduling_details = data_scheduling_details
        draft.lastUpdate = Math.floor(Date.now() / 1000)
        draft.loading = false
        draft.error = false
        draft.success = false
        break
      case LOAD_DATA_DETAILS_SUCCESS:
        draft.dataDetails = dataDetails
        draft.lastUpdate = Math.floor(Date.now() / 1000)
        draft.loading = false
        draft.error = false
        draft.success = success
        break
      case ADD_DATA_SCHEDULING_SUCCESS:
        draft.record = [record].concat(state.record)
        draft.loading = false
        draft.error = false
        draft.success = success
        break

      case REMOVE_DATA_SERVICE_SUCCESS:
        draft.record = [record].concat(state.record)
        draft.loading = false
        draft.error = false
        draft.success = success
        break
      case UPDATE_DATA_SCHEDULING_SUCCESS:
        draft.record = [record].concat(state.record)
        draft.loading = false
        draft.error = false
        draft.success = success
        break
      case LOAD_DATA_SCHEDULING_SERVICE_SUCCESS:
        draft.data_scheduling_services = data_scheduling_services
        draft.lastUpdate = Math.floor(Date.now() / 1000)
        draft.loading = false
        draft.error = false
        draft.success = false
        break
        case LOAD_EXPAND_DATA_SUCCESS:
          draft.expandData = expandData
          draft.lastUpdate = Math.floor(Date.now() / 1000)
          draft.loading = false
          draft.error = false
          draft.success = success
          break
      // case LOAD_EVENT_TEAM_SCHEDULING_SUCCESS:
      // draft.event_team_scheduling = event_team_scheduling
      // draft.lastUpdate = Math.floor(Date.now() / 1000)
      // draft.loading = false
      // draft.error = false
      // draft.success = false
      // break
      case SHOOTER_HISTORY_LIST_SUCCESS:
        draft.shooter_history = shooter_history
        draft.lastUpdate = Math.floor(Date.now() / 1000)
        draft.loading = false
        draft.error = false
        draft.success = false
        break
      case AGENT_VANCANY_LIST_SUCCESS:
        draft.agent_vacancy_details = agent_vacancy_details
        draft.lastUpdate = Math.floor(Date.now() / 1000)
        draft.loading = false
        draft.error = false
        draft.success = false
        break
      case AGENT_OFFICE_VACANCY_LIST_SUCCESS:
        draft.agent_office_details = agent_office_details
        draft.lastUpdate = Math.floor(Date.now() / 1000)
        draft.loading = false
        draft.error = false
        draft.success = false
        break

      case DATA_FINAL_COMMIT_SUCCESS:
        draft.record = [record].concat(state.record)
        draft.loading = false
        draft.error = false
        draft.success = success
        break

      //Nas link
      case LOAD_NAS_LINK_DETAILS_SUCCESS:
        draft.nas_link_details = nas_link_details
        draft.lastUpdate = Math.floor(Date.now() / 1000)
        draft.loading = false
        draft.error = false
        draft.success = false
        break
      case ADD_NAS_LINK_SUCCESS:
        draft.record = [record].concat(state.record)
        draft.loading = false
        draft.error = false
        draft.success = success
        break

      case DELETE_NAS_LINK_SUCCESS:
        draft.deleteNasLinkData = deleteNasLinkData
        draft.loading = false
        draft.error = false
        draft.success = success
        break
      case UPDATE_NAS_LINK_SUCCESS:
        draft.record = [record].concat(state.record)
        draft.loading = false
        draft.error = false
        draft.success = success
        break

      //Data Link

      case LOAD_DATA_LINK_DETAILS_SUCCESS:
        draft.data_link_details = data_link_details
        draft.lastUpdate = Math.floor(Date.now() / 1000)
        draft.loading = false
        draft.error = false
        draft.success = false
        break
      case LOAD_SERVICE_LEVEL_SUCCESS:
        draft.serviceLevel_details = serviceLevel_details
        draft.lastUpdate = Math.floor(Date.now() / 1000)
        draft.loading = false
        draft.error = false
        draft.success = false
        break
      case ADD_DATA_LINK_SUCCESS:
        draft.record = [record].concat(state.record)
        draft.loading = false
        draft.error = false
        draft.success = success
        break

      case DELETE_DATA_LINK_SUCCESS:
        draft.record = [record].concat(state.record)
        draft.loading = false
        draft.error = false
        draft.success = success
        break
      case UPDATE_DATA_LINK_SUCCESS:
        draft.record = [record].concat(state.record)
        draft.loading = false
        draft.error = false
        draft.success = success
        break
      case LOAD_EXPAND_DATA_ERROR:
      case LOAD_DATA_DETAILS_ERROR:
      case LOAD_PENDING_STATUS_ERROR:
      case LOAD_DATA_SCHEDULING_ERROR:
      case ADD_DATA_SCHEDULING_ERROR:
      case UPDATE_DATA_SCHEDULING_ERROR:
      case REMOVE_DATA_SERVICE_ERROR:
      case LOAD_NAS_LINK_DETAILS_ERROR:
      case ADD_NAS_LINK_ERROR:
      case UPDATE_NAS_LINK_ERROR:
      case DELETE_NAS_LINK_ERROR:
      case LOAD_DATA_LINK_DETAILS_ERROR:
      case ADD_DATA_LINK_ERROR:
      case UPDATE_DATA_LINK_ERROR:
      case DELETE_DATA_LINK_ERROR:
      case LOAD_DATA_SCHEDULING_SERVICE_ERROR:
      case SHOOTER_HISTORY_LIST_ERROR:
      case AGENT_VANCANY_LIST_ERROR:
      case AGENT_OFFICE_VACANCY_LIST_ERROR:
      case DATA_FINAL_COMMIT_ERROR:
        draft.loading = false
        draft.error = error
        draft.success = false
        break
      case LOAD_DATA_COPY_ERROR:
      case LOAD_RECORDS_META_DATA_ERROR:
        draft.loading = false
        draft.error = error
        draft.success = false
        break
    }
  })
}
